import React, { useState } from 'react';
import { Box, Typography } from '@mui/material';
import { ChevronRight, ChevronLeft, KeyboardArrowDown, KeyboardArrowUp } from '@mui/icons-material';
import AnswerSheet from './AnswerSheet';
import './AnswerSheet.css';

/**
 * Dock flotante con hoja de respuestas estilo ICFES
 * Se puede minimizar y funciona en desktop y móvil
 */
const AnswerSheetDock = ({
  totalQuestions,
  answers,
  onAnswerSelect,
  currentQuestion,
  onQuestionNavigate,
}) => {
  const [isMinimized, setIsMinimized] = useState(false);
  const isMobile = window.innerWidth <= 600;

  const toggleMinimize = () => {
    setIsMinimized(!isMinimized);
  };

  const answeredCount = Object.keys(answers).length;

  return (
    <Box className={`answer-sheet-dock ${isMinimized ? 'minimized' : ''}`}>
      {/* Botón de toggle */}
      <button className="dock-toggle" onClick={toggleMinimize}>
        {isMinimized ? (
          isMobile ? (
            <>
              <KeyboardArrowUp sx={{ fontSize: 20 }} /> VER HOJA
            </>
          ) : (
            <>
              <ChevronLeft sx={{ fontSize: 20 }} /> HOJA
            </>
          )
        ) : (
          isMobile ? (
            <>
              <KeyboardArrowDown sx={{ fontSize: 20 }} /> OCULTAR
            </>
          ) : (
            <>
              <ChevronRight sx={{ fontSize: 20 }} /> OCULTAR
            </>
          )
        )}
      </button>

      {/* Header */}
      <Box className="dock-header">
        <Typography className="dock-title">
          HOJA DE RESPUESTAS
        </Typography>
        <Typography className="dock-subtitle">
          Click en el número para ir a la pregunta
        </Typography>
      </Box>

      {/* Contenido scrolleable */}
      <Box className="dock-content">
        {Array.from({ length: totalQuestions }, (_, index) => {
          const questionNum = index + 1;
          const isActive = currentQuestion === index;
          const hasAnswer = answers[index] !== undefined;

          return (
            <Box
              key={questionNum}
              className={`answer-sheet-container ${isActive ? 'active' : ''} ${hasAnswer ? 'answered' : ''}`}
              onClick={() => onQuestionNavigate && onQuestionNavigate(index)}
              sx={{
                cursor: 'pointer',
                '&:hover': {
                  bgcolor: isActive ? '#e3f2fd' : '#f5f5f5',
                }
              }}
            >
              <AnswerSheet
                questionNumber={questionNum}
                selectedAnswer={answers[index]}
                onAnswerSelect={(answer) => {
                  onAnswerSelect(index, answer);
                }}
                disabled={false}
              />
            </Box>
          );
        })}
      </Box>

      {/* Footer */}
      <Box className="dock-footer">
        <Box className="dock-summary">
          <Typography className="dock-summary-text">
            <strong>{answeredCount}</strong> de <strong>{totalQuestions}</strong> respondidas
          </Typography>
        </Box>

        <Box className="dock-legend">
          <Box className="dock-legend-item">
            <Box className="dock-legend-oval" />
            <Typography className="dock-legend-text">Sin marcar</Typography>
          </Box>
          <Box className="dock-legend-item">
            <Box className="dock-legend-oval selected" />
            <Typography className="dock-legend-text">Marcada</Typography>
          </Box>
          <Box className="dock-legend-item">
            <Box className="dock-legend-oval current" />
            <Typography className="dock-legend-text">Actual (editable)</Typography>
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default AnswerSheetDock;
